<!-- =========================================================================================
  File Name: fournisseuractualites.vue
  Description: actualites Page
  ----------------------------------------------------------------------------------------

========================================================================================== -->

<template>
<div ref="topFiveDivClient">
    <e-charts autoresize :options="pie" ref="pie" auto-resize :key="keyRender" />
</div>
</template>

<script>
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";
 var months = [
    "JANV",
    "FÉVR",
    "MARS",
    "AVRI",
    "MAI ",
    "JUIN",
    "JUIL",
    "AOÛT",
    "SEPT",
    "OCTO",
    "NOVE",
    "DÉCE"
];
export default {
    name: "fourn-act-pie-chart",

    data() {
        return {
            listeDeMois: "Mois Inclus : ",
            period: this.$store.state.article.analytcsdata.periode,
            keyRender: 0,
            pie: {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                    data: new Array()
                },
                series: [{
                    name: "Somme de Montant",
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    color: ['#B9F2FF',"#E5E4E2",'#28C76F','#7367F0','#1D88E5','#EA5455','#28C76F','#EA5455','#FF9F43','#E5E4E2','#B9F2FF'],
                    data: new Array(),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)"
                        }
                    }
                }]
            }
        };
    },
    components: {
        ECharts
    },
    methods: {
        openLoadingInDiv(refernces) {
            this.$vs.loading({
                background: "#ccc",
                color: "#7d0c3f",
                container: refernces,
                scale: 0.6,
                type: "radius"
            });
        },
        closeLoadingDiv(refernces) {
            this.$vs.loading.close(refernces);
        },

        getdata() {
            this.pie.series[0].data = [];
            let d = new Date().getFullYear();

            let localData = JSON.parse(JSON.stringify(this.$store.state.article.analytcsdata.listData.filter(el => {
                return el.Date.substring(0, 4) == d
            })));
            let i = 0;
           
            let nbreMoiZero = 0;
            for (i = 0; i < localData.length; i++) {
                if (localData[i] != null) {
                    this.pie.series[0].data.push({
                        value: localData[i].Amount,
                        name: months[Number(localData[i].Date.substring(5, 7)) - 1]  +'('+localData[i].Amount+')'
                    });
                    this.pie.legend.data.push(months[Number(localData[i].Date.substring(5, 7)) - 1]+'('+localData[i].Amount+')');
                    if(localData[i].Amount == 0)
                    nbreMoiZero++;
                }
            }
           
            if (nbreMoiZero == localData.length) {
                this.pie.series[0].data = [];
                this.pie.series[0].data.push({
                    value: 0,
                    name: 'Aucun Donnés'
                });
                 this.pie.legend.data.push('Aucun Donnés');
            }
            this.keyRender += this.period
            //this.closeLoadingDiv(this.$refs.topFiveDiv);
            this.playTip();
        },
        playTip() {
            let dataIndex = -1;
            let pie = this.$refs.pie;
            let dataLen = pie.options.series[0].data.length;
            setInterval(() => {
                pie.dispatchAction({
                    type: "downplay",
                    seriesIndex: 0,
                    dataIndex
                });
                dataIndex = (dataIndex + 1) % dataLen;
                pie.dispatchAction({
                    type: "highlight",
                    seriesIndex: 0,
                    dataIndex
                });
                pie.dispatchAction({
                    type: "showTip",
                    seriesIndex: 0,
                    dataIndex
                });
            }, 1000);
        }
    },
    created() {
        if (this.$store.state.article.analytcsdata.listData.length > 0) {
            this.getdata();
        } else
            this.$store.subscribe(mutation => {
                if (mutation.type === "article/UPDATE_ANALTCS_DATA") {
                    this.getdata();

                }
            });
    },
    mounted() {
        //this.openLoadinsgInDiv(this.$refs.topFiveDiv);
    }
};
</script>
